import script from "./InternalPurchaseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalPurchaseManagement.vue?vue&type=script&setup=true&lang=js"

import "./InternalPurchaseManagement.vue?vue&type=style&index=0&id=a5365948&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5365948"]])

export default __exports__